var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bubble"},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))]),_c('span',{staticClass:"delete",on:{"click":function($event){return _vm.$emit('delete')}}},[_vm._v("x")])])}
var staticRenderFns = []

export { render, staticRenderFns }